module.exports = __webpack_public_path__ + "img/ls_logo_header.8b66a864.png";